module.exports = __webpack_public_path__ + "img/poofh3.20e7babc.webp";